import React from "react";
import { useRoutes, useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import PageLayout from "../layout/PageLayout";
import { ROUTES } from "./routes";
import { EASE } from "../components/common/Reveal";

const RouteWrapper = () => {
  const routes = useRoutes(ROUTES);
  return routes;
};

const Pages = () => {
  const location = useLocation();
  const reduce = useReducedMotion();

  const variants = reduce
    ? { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }
    : {
        initial: { opacity: 0, y: 24, filter: "blur(6px)" },
        animate: { opacity: 1, y: 0, filter: "blur(0px)" },
        exit: { opacity: 0, y: -18, filter: "blur(4px)" },
      };

  return (
    <PageLayout>
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={location.pathname}
          initial={variants.initial}
          animate={variants.animate}
          exit={variants.exit}
          transition={{ duration: 0.55, ease: EASE }}
        >
          <RouteWrapper />
        </motion.div>
      </AnimatePresence>
    </PageLayout>
  );
};

export default Pages;
